// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-auction-meta-card',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './auction-meta-card.component.html',
  styleUrl: './auction-meta-card.component.scss',
})
export class AuctionMetaCardComponent {
  label = input.required<string>();
  value = input.required<string>();
  valueClass = input<string>('');
}
